import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2, Mail, Instagram } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'MR',
    name: 'Martín R.',
    location: 'Argentina',
    product: 'Compró el Megapack',
    text: 'Tenía miedo a arruinar un cabello. Ahora hago platinados que parecen de revista. Gano 3x más.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CP',
    name: 'Carlos P.',
    location: 'Colombia',
    product: 'Compró el Megapack',
    text: 'No tenía sistema. Ahora cada cliente recibe el mismo estándar. Sin errores. Sin dudas.',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'DG',
    name: 'Diego G.',
    location: 'México',
    product: 'Compró el Megapack',
    text: 'Imprimí los manuales. Los tengo en mi escritorio. En cada sesión sé exactamente qué hacer.',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró el Megapack',
    text: 'Pasé años viendo videos dispersos. Esta es LA GUÍA que siempre necesité en un paquete.',
    bg: 'bg-brandSteel-deep text-white'
  }];
  return <Section className="bg-bg-alt" data-id="element-168" data-mp="3ubv0ici46ek7">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-169" data-mp="3ua0awkvwdy9s">
        <h2 className="font-display font-bold uppercase md:text-[40px] text-txt-primary mb-3 md:mb-4 text-[24px] tracking-[0.5px]" data-id="element-170" data-mp="3pci2qwppfn2u">
          Lo que dicen{' '}
          <span className="text-brandGold" data-id="element-171" data-mp="1zxka3zlvfccb">los que ya dominan</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-172" data-mp="1uziqndkj9b0b">
          <div className="flex text-gold" data-id="element-173" data-mp="3v21lybhkiwim">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-174" data-mp="3uyurk1qcq8e" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-175" data-mp="7uzhrt2wa9r2">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-176" data-mp="cwf3lncwckai">
            · +500 barberos de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-177" data-mp="msi12fwszur4">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-178" data-mp="rl1f1dzekrwg" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-179" data-mp="vl3jtw0fq1fy">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-180" data-mp="10kyabygasp0h">
                <div className={`w-9 h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-181" data-mp="10iljswwh56bt">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-182" data-mp="1aomrv98spuab">
                  <div className="flex text-gold mb-0.5" data-id="element-183" data-mp="1anlegy4b4vpf">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-184" data-mp="15pjzopdwzijr" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-185" data-mp="11q1ertm3f7gx">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-186" data-mp="1tel31y7w43i6">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-187" data-mp="1kmj649x155cn">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto" data-id="element-188" data-mp="2h605dqzo2ktf">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-189" data-mp="21vlccq4b1yfk">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-190" data-mp="21sfp7gf8l6mh">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-191" data-mp="1nwc9es5410tj">
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-192" data-mp="1rww3tnyatqbz" />
          <h2 className="font-display font-bold uppercase text-[22px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-193" data-mp="2kla284tauoo2">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-194" data-mp="2auowlxf7kjvn">
            <p data-id="element-195" data-mp="2yj84wcy9cwnq">
              Accedes a TODO. Ves los videos. Descargas los manuales. Los
              imprimes. Los usas en tu próximo cliente.
            </p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-196" data-mp="rv7u0td5um7l">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-197" data-mp="11mc7fon6tz0b" />
              devolución del 100%.
            </p>
            <p data-id="element-198" data-mp="11oolhqptrp83">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-199" data-mp="woaqb99bo9rh">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Es para alguien que recién empieza o que ya trabaja?',
    a: 'Para quien YA TRABAJA EN BARBERÍA pero tiene todo disperso. Si ya cortás y tienes experiencia con color, esto es lo que faltaba para dominar realmente. No es una introducción básica, es el siguiente nivel donde ganas dinero de verdad.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'Pagas en dólares (USD), pero el sistema convierte automáticamente a tu moneda local en el checkout. Argentina pesos, México pesos, Colombia pesos, etc.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Instantáneamente en tu correo. Todos los videos, PDFs y bonos listos para descargar. Puedes verlo en tu celular o descargarlo e imprimirlo.'
  }, {
    q: '¿Necesito alguna certificación previa para aprovecharlo?',
    a: 'No. Solo que tengas experiencia trabajando en barbería. El sistema es progresivo: desde fundamentos hasta técnicas avanzadas.'
  }, {
    q: '¿Funciona si trabajo de forma independiente y no en una barbería?',
    a: '100%. Muchos usuarios trabajan en sus propios locales o en domicilios. El sistema se adapta.'
  }, {
    q: '¿Tiene garantía real o es un bluff?',
    a: 'Garantía real. 7 días completos. Si no te gusta, te devolvemos el dinero. Punto.'
  }, {
    q: '¿Puedo usar el megapack con mis clientes?',
    a: 'Sí. Los manuales son tuyos. Los videos también. Los bonos (fichas, cartas de color) están diseñados para usar con clientes.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'Para siempre. Pago único. Acceso ilimitado.'
  }, {
    q: '¿Qué formato exacto es?',
    a: '15 Videos en MP4 HD (descargables). 4 Manuales en PDF (descargables). 5 Bonos en PDF (descargables e imprimibles).'
  }, {
    q: '¿Hay actualizaciones incluidas?',
    a: 'Sí. Si agregamos nuevas técnicas o módulos, tú los recibes sin costo extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-200" data-mp="2lh3pqlhra4mn">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-201" data-mp="2ghhdae9r4sew">
        <h2 className="font-display font-bold uppercase text-[24px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-txt-primary text-center mb-8 md:mb-10" data-id="element-202" data-mp="2gik2mhrfemsp">
          ❓ LO QUE MÁS NOS <span className="text-brandGold" data-id="element-203" data-mp="26it9ajelqdu7">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-204" data-mp="26lntqaxm7ynm">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-205" data-mp="3vbe9kfifrgbq" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-206" data-mp="3lhp3nlu02zxx">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-207" data-mp="3ghsznmlaz8id">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandGold shrink-0" size={20} data-id="element-208" data-mp="37oppbn5yfbry" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-209" data-mp="2sryn764wblyn" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-210" data-mp="2e3yo7go8en6y">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Años buscando en YouTube, Instagram y con otros barberos',
    costo: 'Conocimiento disperso y sin sistema'
  }, {
    sin: '3-4 horas buscando cada fin de semana',
    costo: '156-208 horas perdidas por año (4-5 semanas de trabajo)'
  }, {
    sin: 'No tener TODO en un lugar organizado',
    costo: 'Sesiones sin estructura, improvisación'
  }, {
    sin: 'Cometer errores químicos constantemente',
    costo: 'Clientes insatisfechos, mala reputación, dinero perdido'
  }, {
    sin: 'No dominar realmente las técnicas',
    costo: 'Nunca llegar a precios premium'
  }, {
    sin: 'Seguir comprando cursos sueltos y costosos',
    costo: 'Dinero y tiempo desperdiciados sin fin'
  }];
  return <Section className="bg-bg-base" data-id="element-211" data-mp="3968rdi4bjzz7">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-212" data-mp="394xrhtdzvcdd">
        <h2 className="font-display font-bold uppercase text-[26px] md:text-[40px] leading-[1.2] tracking-[0.5px] text-center text-txt-primary mb-8 md:mb-12" data-id="element-213" data-mp="3475zkzdcnq96">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-214" data-mp="rqodut8jamg" />
          <span className="text-brandGold" data-id="element-215" data-mp="q5um7eqvvpn">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-216" data-mp="3rxrv5r663i2a">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-217" data-mp="3nv561y0vsb8s">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-218" data-mp="3ix3q3lyr4s1j">
              Sin el Megapack
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-219" data-mp="2chjanv4fhdet">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-220" data-mp="n0p3lwks41i4">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-221" data-mp="rxxnq2phmfm0" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-222" data-mp="vz14crfd0foa">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-start gap-1.5" data-id="element-223" data-mp="15p2iorhwujq0">
                  <span aria-hidden="true" data-id="element-224" data-mp="1fo1s4cai2je2">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-225" data-mp="1jnsocvisprpz">
          Tu próxima sesión puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandGold';
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-226" data-mp="nozy3xlqt9l4">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-227" data-mp="11oitrqxdasgj">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-228" data-mp="xkt8babzoqzq">
          <p className="font-display font-bold uppercase text-[20px] md:text-[32px] leading-[1.3] tracking-[0.5px] text-txt-primary" data-id="element-229" data-mp="xnz0iyfx08zo">
            Puedes seguir buscando información en{' '}
            <span className="text-brandGold" style={{
            textShadow: '0 0 12px rgba(212,162,76,0.28)'
          }} data-id="element-230" data-mp="16maosttb6uoy">
              10 lugares
            </span>
            ,
            <br data-id="element-231" data-mp="1ubvjub2qliel" />o tener TODO en UNO — organizado, listo, dominable.
          </p>
          <p className="font-display font-bold uppercase text-[26px] md:text-[38px] leading-[1.2] tracking-[0.5px] text-brandGold animate-pulse mt-3" data-id="element-232" data-mp="1u9shqsob7yti">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-233" data-mp="28x0wu4kqooar">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-234" data-mp="2dwvqgfvwfrzi">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-235" data-mp="23y69qqfqodku"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] mb-3 md:mb-4 ${accent}`} data-id="element-236" data-mp="1uz2obft3nm36">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className={`inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 px-5 py-3 md:px-6 md:py-4 rounded-[14px] transition-colors ${isUrgent ? 'border-danger shadow-[0_0_30px_rgba(239,68,68,0.45)] animate-red-glow' : 'border-brandGold shadow-[0_0_30px_rgba(212,162,76,0.35)] animate-glow-button'}`} data-id="element-237" data-mp="1g8bvc4frugyh">
            {[hours, minutes, seconds].map((unit, i) => <React.Fragment key={i} data-id="element-238" data-mp="za3neiqfcwn0" data-mpi={i}>
                {i > 0 && <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-239" data-mp="uhk9tlrqm1i7">
                    :
                  </span>}
                <span className={`font-display font-bold text-[30px] md:text-[40px] leading-none ${accent}`} data-id="element-240" data-mp="lhnpfwcdrosy">
                  {unit.toString().padStart(2, '0')}
                </span>
              </React.Fragment>)}
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-241" data-mp="7hw9vr67u0cu">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-242" data-mp="21vx767m4afat">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandGold text-left shadow-[0_0_50px_rgba(212,162,76,0.18)]" data-id="element-243" data-mp="21wf7pgftbfoj">
            <h4 className="font-display font-bold uppercase text-[16px] md:text-[22px] leading-[1.25] tracking-[0.5px] text-txt-primary text-center" data-id="element-244" data-mp="3os3m6cr8if21">
              MEGAPACK COLORIMETRÍA{' '}
              <span className="text-brandGold" data-id="element-245" data-mp="1f1dx33otxsq">LISTA™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-246" data-mp="1hdv3e1mg44q">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-247" data-mp="35vlq5j5crszz">
              {['15 Módulos en Video HD — 15 horas de entrenamiento', '4 Manuales Completos — 475+ páginas organizadas', '5 Bonos listos para imprimir — Sin costo extra', 'TODO lo que necesitas dominar en un solo acceso', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-248" data-mp="2q6tgvmlqvp34">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-249" data-mp="2q968ysl7vftw" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-250" data-mp="305sr39m5rss8">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-251" data-mp="27fu19c053rmi">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-252" data-mp="22i0scb7gcjij">
                Valor original
              </p>
              <p className="font-display font-bold text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-253" data-mp="2h885cbeoxabu">
                USD $223
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandGold/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-254" data-mp="1oo1558prxqak">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandGold" data-id="element-255" data-mp="3vemmxvq116vb">
                Acceso completo hoy por
              </p>
              <p className="font-display font-bold text-[40px] md:text-[54px] leading-none text-brandGold mt-1" data-id="element-256" data-mp="41rvzgjdh32x">
                $27{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-257" data-mp="3qersxjayg161">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-258" data-mp="hxdhveub76r4">
                87% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-259" data-mp="8y09yqlu2q8i">
                Pago único · Incluye garantía de 7 días
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-260" data-mp="2tor79t5vu0sy" />

            <div className="mt-4 md:mt-5" data-id="element-261" data-mp="2trde1qky8ca4">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[13.5px] md:!text-base" data-id="element-262" data-mp="2yp56qmtf42fd">
                🎨 DOMINA LA COLORIMETRÍA — ACCESO AHORA
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-263" data-mp="3bfpkmkwikeko">
          <span className="flex items-center gap-2" data-id="element-264" data-mp="cyv4l1csnsfj">
            <Lock size={14} data-id="element-265" data-mp="7xfjxaej3nxo" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-266" data-mp="36z63p6sq0as">
            <Clock size={14} data-id="element-267" data-mp="35o0rkxpckhk" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-268" data-mp="3uds7ou5i41fu">
            <ShieldCheck size={14} data-id="element-269" data-mp="3ud0c3jbwm3pk" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-270" data-mp="vobg0jq0p5aq">
            <CreditCard size={14} data-id="element-271" data-mp="qw9yojdzsodu" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-272" data-mp="136j3fdfyyx3a">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-273" data-mp="138vlrrpn39gv">
        <div data-id="element-274" data-mp="1852shmpv0ozv">
          <h2 className="font-display font-bold uppercase tracking-[0.5px] text-base md:text-xl text-txt-primary mb-1 leading-snug" data-id="element-275" data-mp="184ay2f800xb6">
            🎨 MEGAPACK COLORIMETRÍA LISTA™
          </h2>
          <p className="font-sans font-bold text-sm text-brandGold" data-id="element-276" data-mp="1h5sho7km7h4m">
            by NERO BARBER
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-277" data-mp="1m3kad3t3379v">
          El megapack profesional número 1 para barberos en Latinoamérica.
          Porque aprender disperso en 10 lugares es perder años. Aquí lo tienes
          TODO: videos, manuales, fórmulas exactas y bonos de impacto.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 font-sans text-[13px] text-txt-muted pt-4" data-id="element-278" data-mp="24w4qdknophw9">
          <a href="mailto:Soportenerobarber@gmail.com" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-279" data-mp="34da6ezmnl2s7">
            <Mail size={14} aria-hidden="true" data-id="element-280" data-mp="3e9wppjzbzls4" />
            Soportenerobarber@gmail.com
          </a>
          <a href="https://www.instagram.com/Nero_barber_ok" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-txt-primary transition-colors" data-id="element-281" data-mp="3icja4ztoa4fa">
            <Instagram size={14} aria-hidden="true" data-id="element-282" data-mp="3s8cwtc13veas" />
            @Nero_barber_ok
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-283" data-mp="xmjw7m2dpwe">
          <p className="font-sans text-xs text-txt-faint" data-id="element-284" data-mp="5tl6pqrquzup">
            © 2025 NERO BARBER. Todos los derechos reservados. Precios en
            dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-285" data-mp="ew2qzznu9if2">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-286" data-mp="1zdv3s2syjdv4">
              Términos y condiciones
            </a>
            <span data-id="element-287" data-mp="1udh71gwt3qce">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-288" data-mp="1ugd4z58nmf0u">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};